import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import loadSingleFont from 'helpers/loadSingleFont';
import {isEqual, reduce} from 'lodash';
import { setNotification } from 'components/Notifications/actions';

import {
  Editor,
  EditorState,
  convertFromRaw,
  CompositeDecorator,
} from 'draft-js';

import { stateFromMarkdown } from 'draft-js-import-markdown';

import isJson from 'helpers/isJson';

import getContent from 'components/Templates/general/getContent';

import TextEditorLink from './TextEditorLink';

import colorStyleMap from './helpers/colorStyleMap';
import blockStyleMap from './helpers/blockStyleMap';
import findLinkEntities from './helpers/findLinkEntities';
import customInlineStylesMap from './helpers/customInlineStylesMap';

import getFontsMap from './helpers/getFontsMap';
const fontMap = getFontsMap();

import TextEditorWrapper from './styles/TextEditorWrapper';
function handleUpdateText(props, isCompare) {

  const {
    typeOfStyle,
    componentPayload,
    language,
    defaultValues,
    editorViewportContent
  } = props;

  const thisLanguage = language ? language : 'en';

  const {
    content
  } = componentPayload;

  const hasContent = content && content[typeOfStyle];
  const thisContent = hasContent ? content : defaultValues;

  const getValue = getContent({
    typeOfStyle: typeOfStyle ? typeOfStyle : componentPayload.typeOfStyle ? componentPayload.typeOfStyle : '',
    editorViewportContent: editorViewportContent,
    language: thisLanguage,
    content: thisContent
  });

  const getStateValue = getValue && getValue.value ? isJson(getValue.value) : '';

  if (getStateValue && getStateValue.blocks) getStateValue.blocks.map((thisMap) => {
    if (thisMap && thisMap.inlineStyleRanges) thisMap.inlineStyleRanges.map((thisInline) => {
      if (thisInline && thisInline.style && fontMap[thisInline.style] && fontMap[thisInline.style].fontFamily) loadSingleFont(fontMap[thisInline.style].fontFamily, null, props.frameRef ? props.frameRef : null);
    });
  });

  if (isCompare) {
    return getStateValue ? getStateValue : getValue && getValue.value ? getValue.value : '';
  }


  const editorInitialState = getStateValue ? convertFromRaw(getStateValue) : getValue && getValue.value ? stateFromMarkdown(getValue.value) : '';


  const decorator = new CompositeDecorator([
    {
      strategy: findLinkEntities,
      component: TextEditorLink,
      props: props
    },
  ]);

  return {
    state: EditorState.createWithContent(editorInitialState, decorator),
    content: thisContent,
    isDefault: !hasContent && getValue && getValue.value && getValue.value.includes('Lorem ipsum')
  };
}


class TextEditorGenerator extends React.Component {

  constructor(props) {
    super();
    this._isMounted = false;

    this.wrapperRef = React.createRef();
    

    this.thisResize = this.thisResize.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
    
    const getState = handleUpdateText(props);
    const getStateToCompare = handleUpdateText(props, true);

    this.state = {
      editorState: getState.state,
      content: getState.content,
      isDefault: getState.isDefault,
      mounted: false,
      stateToCompare: getStateToCompare
    };
  }


  stopPropagation(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  thisResize(element) {

    const thisElement = element ? element : this.wrapperRef.current;

    if (!thisElement.tagName || thisElement.tagName === 'BODY' || thisElement.tagName === 'HTML') return true;
    if (window.getComputedStyle(thisElement).display === "none") {      
      return false;
    }

    if (!thisElement.parentNode.tagName || thisElement.parentNode.tagName === 'BODY' || thisElement.parentNode.tagName === 'HTML') return true;
    if (window.getComputedStyle(thisElement.parentNode).display === "none") {
      return false;
    }

    if (thisElement && thisElement.parentNode) {
      return this.thisResize(thisElement.parentNode);
    }
    return true;
  }


  componentDidMount() {
    this._isMounted = true;
    if (this.state.isDefault) {
      this.setState({
        mounted: true
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;

  }

  // shouldComponentUpdate(nextProps, state) {


  //   const getNewState = handleUpdateText(nextProps, true);
  //   // return true
  //   if (!isEqual(state.stateToCompare, getNewState) || this.props.editorViewportContent !== nextProps.editorViewportContent) {
  //     return true;
  //   }

  //   return false;

  // }

  // static getDerivedStateFromProps(props, state) {

  //   const {
  //     content,
  //   } = state;


  //   const getNewState = handleUpdateText(props);
  //   // console.log(props)
  //   if (!isEqual(content, getNewState.content) || state.editorViewportContent !== props.editorViewportContent) {
  //     return {
  //       editorState: getNewState.state,
  //       content: getNewState.content,
  //       editorViewportContent: props.editorViewportContent
  //     };
  //   }
  //   return null;
  // }
  componentDidUpdate(prevProps, prevState) {

    const {
      content,
    } = this.state;

    if (!this._isMounted) return;

    const getNewStateCompare = handleUpdateText(this.props, true);

    if (!this.props.isSaving && !isEqual(this.state.stateToCompare, getNewStateCompare)) {
      const getNewState = handleUpdateText(this.props);

      this.setState({
        editorState: getNewState.state,
        content: getNewState.content,
        stateToCompare: getNewStateCompare
      });
    }


  }

  render() {
    const { editorState, mounted } = this.state;

    const { bulletStyling } = this.props;

    const styleMap = customInlineStylesMap;

    return (
      <TextEditorWrapper bulletStyling={bulletStyling}  onClick={this.props.isEditor ? this.stopPropagation : null}>
        {
           this.props.isEditor || !this.state.isDefault ? (
            <Editor
              editorState={editorState}
              readOnly={true}
              customStyleFn={colorStyleMap}
              blockStyleFn={blockStyleMap}
              customStyleMap={styleMap}
            />
          ) : ''
        }

      </TextEditorWrapper>
    );
  }
}

TextEditorGenerator.propTypes = {
  typeOfStyle: PropTypes.string,
  content: PropTypes.object,
  componentPayload: PropTypes.object,
  language: PropTypes.string,
  defaultValues: PropTypes.object,
};


const mapStateToProps = createStructuredSelector({
});

function mapDispatchToProps(dispatch) {
  return {
    dispatchSetNotification: payload => dispatch(setNotification(payload))
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(TextEditorGenerator);